export enum AddressTypes {
  mailing = 'mailing',
  billing = 'billing',
  livestock = 'livestock',
}
